/* prettier-ignore */

import { Component, computed, inject } from '@angular/core';
import { ModalController } from '@ionic/angular';
import { GamificationService } from 'src/app/shared/gamification/services/gamification.service';
import { AuthService } from 'src/app/auth/services';
import { ToolsService } from 'src/app/services/tools.service';
import { UserService } from 'src/app/user/services';
import { RegisterComponent } from 'src/app/shared/register/register.component';
import { LocalStorageService } from 'src/app/services';

@Component({
  selector: 'header-user-menu',
  templateUrl: './user.component.html',
  styleUrl: './user.component.scss',
})

export class HeaderUserMenuComponent {
  private _authService = inject(AuthService);
  protected _toolsService = inject(ToolsService);
  private _userService = inject(UserService);
  private _modalCtrl = inject(ModalController);
  private _gamificationService = inject(GamificationService);
  private _localStorageService = inject(LocalStorageService);

  protected user = this._authService.user;
  public passportEnabled = this._gamificationService.passportsEnabled;
  public showSavedRoutes = computed(() => this._toolsService.canUseRoutes());
   

  async register(){
      this._localStorageService.setItem('pop-up-actived', false);

      this._modalCtrl.dismiss().catch(e => {
          console.warn("No modal found on dismiss")
      });
      const registerModal = await this._modalCtrl.create({
          component: RegisterComponent,
          cssClass: ['registerModal', 'ion-disable-focus-trap'],
      });
      await registerModal.present();
  }

  login(){
      this._localStorageService.setItem('pop-up-actived', false);

      this._userService.login();
  }

  logout(){
      this._authService.logout();
      this._userService.resetAll();
  }

  protected getUserIconLetter(): string {
    const user = this.user();
    if(!user) return '';

    const userName = user.name;
    const userEmail = user.email;

    if (userName && userName.length > 0) {
      return userName.charAt(0).toUpperCase();
    } else if (userEmail && userEmail.length > 0) {
      return userEmail.charAt(0).toUpperCase();
    } else {
      return '';
    }
  }
}
